/* eslint class-methods-use-this: ["error", { "exceptMethods": ["getAccountScopedUrl"] }] */

import ApiClient from './ApiClient';

class KanbanCardsApi extends ApiClient {
  constructor() {
    super('kanban/pipelines', { accountScoped: true });
  }

  getCards(pipelineId) {
    return axios.get(`${this.url}/${pipelineId}/cards`);
  }

  getCard(pipelineId, cardId) {
    return axios.get(`${this.url}/${pipelineId}/cards/${cardId}`);
  }

  createCard(pipelineId, payload) {
    return axios.post(`${this.url}/${pipelineId}/cards`, payload);
  }

  updateCard(pipelineId, cardId, payload) {
    return axios.put(`${this.url}/${pipelineId}/cards/${cardId}`, payload);
  }

  deleteCard(pipelineId, cardId) {
    return axios.delete(`${this.url}/${pipelineId}/cards/${cardId}`);
  }

  moveCard(pipelineId, cardId, payload) {
    return axios.patch(
      `${this.url}/${pipelineId}/cards/${cardId}/move`,
      payload
    );
  }

  getCardActivities(pipelineId, cardId, params = {}) {
    return axios.get(`${this.url}/${pipelineId}/cards/${cardId}/activities`, {
      params,
    });
  }

  updateCardStatus(pipelineId, cardId, status) {
    return axios.patch(`${this.url}/${pipelineId}/cards/${cardId}`, {
      card: { status },
    });
  }
}

export default new KanbanCardsApi();
